//-----------------------------------------------------------------------
// <copyright file="app.module.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
// Angular Material Imports
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioButton, MatRadioModule } from "@angular/material/radio";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from "@azure/msal-angular";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
//Components Imports
import { ExportAsModule } from "ngx-export-as";
import { environment } from "../environments/environment.onprem";
import { AppComponent } from "./app.component";
import { AuditComponent } from "./audit/audit.component";
import { ExcelService } from "./audit/excel.service";
import { AzureAdDemoService } from "./azureAd/azure-ad-demo.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DialogBoxComponent } from "./dialog-box/dialog-box.component";
import { EditDialogBoxComponent } from "./edit-dialog-box/edit-dialog-box.component";
import { LoginComponent } from "./login/login.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { ApiService } from "./services/api.service";
import { TransactionsComponent } from "./transactions/transactions.component";
import { UserComponent } from "./user/user.component";

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "dashboard", component: NavbarComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    TransactionsComponent,
    AuditComponent,
    UserComponent,
    DialogBoxComponent,
    NavbarComponent,
    EditDialogBoxComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatIconModule,
    MatRadioModule,
    MatListModule,
    MatCheckboxModule,
    MatDividerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatTableModule,
    MatIconModule,
    MatIcon,
    MatRadioButton,
    MatDialogModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    ExportAsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledNonBlocking" ,
    }),
    FormsModule,
    HttpClientModule,
    // Azure Ad module for authentication
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: "",
          authority:
            "",
          redirectUri: `${environment.envVar.postLogoutUrl}/dashboard`,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ["user.read.all"],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          [
            "https://prjone.onmicrosoft.com/User.Read.All",
            ["User.Read.All"],
          ],
        ]),
      }
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,
    AzureAdDemoService,
    ApiService,
  ],
  bootstrap: [
    AppComponent,
    MsalRedirectComponent,
    ExcelService,
    DashboardComponent,
    NavbarComponent,
  ],
})
export class AppModule {}
